import { Capacitor, registerPlugin } from '@capacitor/core';

const plugin = registerPlugin('ExpenseShortcuts');
export const isNativeExpenseAvailable = () => Capacitor.getPlatform() === 'ios' && Capacitor.isPluginAvailable('ExpenseShortcuts');
export const consumeExpenseShortcut = () => plugin.consumePendingShortcut();
export const addExpenseShortcutListener = (callback) => plugin.addListener('shortcutRequested', callback);
export const addExpenseActiveListener = (callback) => plugin.addListener('appActive', callback);
export const isExpenseWidgetAvailable = async () => {
  if (!isNativeExpenseAvailable()) return false;
  // Older app binaries may run the latest UI without containing the extension.
  try { return (await plugin.getWidgetSupport()).supported === true; } catch (_) { return false; }
};
export const captureExpensePhoto = async () => {
  const photo = await plugin.capturePhoto();
  if (photo.cancelled) return null;
  const bytes = Uint8Array.from(atob(photo.base64), (char) => char.charCodeAt(0));
  return new File([bytes], `ticket-${Date.now()}.jpg`, { type: 'image/jpeg', lastModified: Date.now() });
};

const PENDING_PATH = 'smt.quickExpense.returnTo';
export const rememberQuickExpensePath = (path) => {
  if (/^\/expense-tickets\/quick(?:\?capture=1)?$/.test(path)) sessionStorage.setItem(PENDING_PATH, path);
};
export const pendingQuickExpensePath = () => {
  const path = sessionStorage.getItem(PENDING_PATH) || '';
  return /^\/expense-tickets\/quick(?:\?capture=1)?$/.test(path) ? path : '/dashboard';
};
export const clearQuickExpensePath = () => sessionStorage.removeItem(PENDING_PATH);
